import { useMemo, useRef } from 'react'

export interface SwipeOptions {
  onLeft: () => void
  onRight: () => void
  threshold?: number
}

export function useSwipe({ onLeft, onRight, threshold = 50 }: SwipeOptions) {
  const startX = useRef(0)

  const handlers = useMemo(
    () => ({
      onTouchStart: (e: React.TouchEvent) => {
        startX.current = e.touches[0].clientX
      },
      onTouchEnd: (e: React.TouchEvent) => {
        const dx = e.changedTouches[0].clientX - startX.current
        if (dx > threshold) onRight()
        else if (dx < -threshold) onLeft()
      },
    }),
    [onLeft, onRight, threshold],
  )

  return handlers
}
